export default "__VITE_ASSET__b3c86c3f__"